<template>
<div id="addEdit">
  <el-dialog :title="formData.category_id?'编辑分类':'添加分类'" :visible.sync="visible" width="600px"	@closed="ueShow=false">

    <el-form :model="formData" :rules="rules" ref="form"  label-width="80px" class="demo-ruleForm" size="small">
      <el-form-item prop="name" label="分类名称">
        <el-input v-model="formData.name" placeholder="请输入分类名称"></el-input>
      </el-form-item>
      <el-form-item prop="pid" label="所属分类">
        <el-select v-model="formData.pid" placeholder="请选择所属分类" style="width: 100%;">
          <el-option label="顶级分类" :value="0"></el-option>
          <el-option v-for="item in cateList" :key="item.id" :label="item.name" :value="item.category_id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="分类图片" prop="cover.file_id" :rules="[{ required: true, message: '请上传分类图片', trigger: 'change' }]">
        <el-button type="primary" @click="isupload=true">选择图片</el-button>
        <div v-if="formData.cover.file_id" class="img">
          <img :src="formData.cover.file_path" width="100" height="100" />
        </div>
      </el-form-item>

      <el-form-item label="鉴定信息" prop="content" v-if="formData.pid!=0">
        <Uediter v-if="ueShow" :config="config"  :text="formData.content"  v-model="formData.content" @contentChange="contentChange"></Uediter>
      </el-form-item>



    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="submitSave" :loading="loading">确定</el-button>
    </div>

  </el-dialog>

  <Upload v-if="isupload" :isupload="isupload" @returnImgs="uploadChange">上传图片</Upload>


</div>
</template>

<script>
import Uediter from '@/components/UE.vue';
import AppraisalApi from '@/api/appraisal'
import Upload from '@/components/file/Upload';
export default {
  components:{Upload,Uediter},
  data(){
    return{
      config: {
        initialFrameWidth: '100%',
        initialFrameHeight: 400,
      },
      ueShow:true,
      loading:false,
      visible:false,
      isupload:false,
      formData:{
        name:'',
        pid:0,
        cover:{},
        content:'',
      },
      rules: {
        name: [{ required: true, message: '请输入分类名称', trigger: 'blur' }],
        pid: [{ required: true, message: '请选择所属分类', trigger: 'change' }],
        content: [{ required: true, message: '请输入鉴定信息', trigger: 'blur' }],
        // cover: [{ required: true, message: '请上传分类图片', trigger: 'change' }],
      },
    }
  },
  props:{
    cateList:Array,
  },
  methods:{


    /*提交保存*/
    submitSave(){
      let params = JSON.parse(JSON.stringify(this.formData));
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          let API=this.formData.category_id?'setCategoryEdit':'categoryAdd'
          params.cover_id=params.cover.file_id
          AppraisalApi[API](params).then(data => {
            this.$message({
              message: '保存成功',
              type: 'success'
            });
            this.visible=false
            this.$emit('refresh')
          }).finally(() => {
            this.loading = false;
          });
        }
      });
    },

    /*显示弹窗*/
    show(e){
      this.visible=true
      this.formData.category_id=null
      this.formData.content=''
      this.$nextTick(()=>{
        this.$refs.form.resetFields()
        if(e&&e!=''){
          this.formData.category_id=e.category_id
          for(let i in this.formData){
            if(e[i]){
              this.formData[i]=e[i]
            }
          }
          this.formData.cover={
            file_id:e.cover_id,
            file_path:e.file_path,
          }
        }
        this.ueShow=true
      })
    },

    // 图片选择
    uploadChange(e){
      // console.log(e);
      if(e&&e!=''){
        this.formData.cover=e[0];
      }
      this.isupload=false
    },

    contentChange(e){
      this.formData.content=e
    },

  },

}
</script>

<style lang="scss" scoped>
.img{margin-top: 10px;}
</style>



// WEBPACK FOOTER //
// src/views/appraisal/category/addEdit.vue